<!-- eslint-disable vue/html-indent -->
<script>
import ChatNoteProfile from "./ChatNoteProfile.vue"

export default {
    props: ["chatNoteData"],
    components: {
        ChatNoteProfile,
    },
    data() {
        return {
            noteType: "Note",
            noteTagInput: "",
        }
    },
    methods: {
        createNewNoteOrTag() {
            if (this.noteType === "Note") {
                this.$emit("on-note-submit", this.noteTagInput)
            } else {
                this.$emit("on-tag-submit", this.noteTagInput)
            }

            this.noteTagInput = ""
        },
    },
}
</script>

<template>
    <div
        class="position-absolute h-75 w-25 top-right bg-white p-2 round shadow d-flex flex-column justify-content-between mb-3"
    >
        <div class="h-100 d-flex flex-column">
            <div class="d-flex justify-content-between">
                <!-- Note type selector -->
                <div class="form-group w-30">
                    <select
                        v-model="noteType"
                        class="form-control rounded-pill border-0 no-shadow bg-primary text-white"
                    >
                        <option selected>Note</option>
                        <option>Tag</option>
                        <option>Profile</option>
                    </select>
                </div>

                <!-- Note dismiss button -->
                <button
                    class="btn btn-danger rounded-circle p-0 circle-size"
                    @click="$emit('close-btn-click')"
                >
                    <feather-icon icon="XIcon" class="text-white" size="18" />
                </button>
            </div>

            <ChatNoteProfile v-if="noteType === 'Profile'" />
            <!-- Note list -->
            <div v-if="noteType !== 'Profile' && chatNoteData">
                <div
                    v-if="noteType === 'Note'"
                    v-for="note in chatNoteData.chatNotes"
                    :key="note.id"
                    class="bg-tertiary text-dark p-small rounded-pill mt-1"
                >
                    <!-- show the list of notes or tags here -->
                    {{ note.note }}
                    <div
                        v-if="noteType === 'Tag'"
                        v-for="tag in chatNoteData.chatTags"
                        :key="tag.id"
                    >
                        {{ tag.tag }}
                    </div>
                </div>
                <div
                    v-if="noteType === 'Tag'"
                    v-for="tag in chatNoteData.chatTags"
                    :key="tag.id"
                    class="bg-tertiary text-dark p-small rounded-pill mt-1"
                >
                    <!-- show the list of notes or tags here -->
                    {{ tag.tag }}
                </div>
            </div>
        </div>

        <!-- Note input -->
        <form
            v-if="noteType !== 'Profile'"
            class="w-100 d-flex justify-content-center"
        >
            <input
                class="form-control no-shadow mr-1 round"
                :placeholder="noteType === 'Note' ? 'Add a note' : 'Add a tag'"
                type="text"
                v-model="noteTagInput"
            />
            <button
                @click.prevent="createNewNoteOrTag"
                class="btn btn-primary round"
                type="submit"
            >
                Submit
            </button>
        </form>
    </div>
</template>

<style>
.top-right {
    top: 140px;
    right: 0px;
    margin-right: 30px;
    z-index: 1000;
}

.no-shadow {
    box-shadow: none !important;
}

.p-small {
    padding: 10px 10px 10px 15px !important;
}

.circle-size {
    width: 25px;
    height: 25px;
}

.w-30 {
    width: 30% !important;
}

.bg-tertiary {
    background-color: #eef2f7 !important;
}
</style>
